import { connect } from 'react-redux';

import CommitmentUpsellBanner from '../components/sidebar/upsells/CommitmentUpsellBanner';
import { requestCommitmentUpsellModalVisibility } from '../actions';
import { hasOrderLineItemWithOfferingId } from '../selectors';

const mapStateToProps = (state, props) => ({
  lineItemsContainOfferingId: hasOrderLineItemWithOfferingId(
    state.currentOrder,
    props.evergreenOffering.id
  ),
  lineItems: state.currentOrder.line_items,
  isMembershipOrder: state.currentOrder.membership_order,
  userIsSubscribed: state.subscribed,
});

export const mapDispatchToProps = dispatch => ({
  handleAddToCartClick: () => {
    dispatch(requestCommitmentUpsellModalVisibility(true));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommitmentUpsellBanner);
